import SimpleVast from '../index';
import { isHttpUrl } from '../lib';

export function playNonLinearAd(creative) {
  creative.variations.forEach((variation) => {
    let container = null;

    if (variation.staticResource) {
      container = document.createElement('div');
      SimpleVast.applyNonLinearCommonDomStyle(container);
      container.style.maxWidth = variation.expandedWidth;
      container.style.maxHeight = variation.expandedHeight;

      const img = document.createElement('img');
      img.src = variation.staticResource;
      img.addEventListener('click', () => {
        if (isHttpUrl(variation.nonlinearClickThroughURLTemplate)) {
          window.open(variation.nonlinearClickThroughURLTemplate, '_blank');
        }
        this.nonLinearVastTracker.click(null, this.macros);
      });

      const closeBtn = SimpleVast.getCloseButton(() => container.remove());
      if (variation.minSuggestedDuration && variation.minSuggestedDuration > 0) {
        closeBtn.style.display = 'none';
        setTimeout(() => {
          closeBtn.style.display = 'block';
        }, variation.minSuggestedDuration * 1000);
      }

      container.appendChild(img);
      container.appendChild(closeBtn);
    } else if (isHttpUrl(variation.iframeResource)) {
      // An HTMLResource is not rendered: inserted as markup, the ad's scripts would run in this
      // page's origin.
      container = document.createElement('iframe');
      SimpleVast.applyNonLinearCommonDomStyle(container);
      container.src = variation.iframeResource;
      container.style.maxWidth = variation.expandedWidth;
      container.style.maxHeight = variation.expandedHeight;
      container.addEventListener('click', () => {
        if (isHttpUrl(variation.nonlinearClickThroughURLTemplate)) {
          window.open(variation.nonlinearClickThroughURLTemplate, '_blank');
        }
        this.nonLinearVastTracker.click(null, this.macros);
      });
      if (variation.minSuggestedDuration && variation.minSuggestedDuration > 0) {
        setTimeout(() => container.remove(), variation.minSuggestedDuration * 1000);
      }
    }

    if (!container) return;

    this.nonLinearVastTracker.trackImpression(this.macros);
    this.domElements.push(container);

    if (variation.adSlotID) {
      const slot = document.getElementById(variation.adSlotID);
      if (slot) slot.appendChild(container);
    } else {
      this.video.parentElement.appendChild(container);
    }
  });
}